// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-preferred -> weidner-apartment-homes-preferred -> skyline-farmers-market-b989
// Generated: 2026-11-02T15:45:43.342Z
// Counts: 1 design, 91 content, 28 slot group, 4 collection binding, 11 section, 4 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibilityhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_title": {
    "overrideType": "VALUE",
    "customValue": "Test",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Find Your Home</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "faqhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Floor Plans</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Find Your New Home</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "© 2026 All Rights Reserved.",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Studio - 2 Bedroom Apartments for Rent in Dallas, TX</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Skyline Farmers Market</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Enjoy luxury living with a pool at Liberty Pointe in Oklahoma City. Discover the perfect blend of comfort and luxury in our beautiful community.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments with Pool in OKC</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "neighborhoodcallout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Nestled in the vibrant heart of Dallas, Skyline Farmers Market offers a variety of floor plans, from cozy studios to spacious two-bedrooms. Immerse yourself in the local culture as you stroll through nearby parks, trendy cafes, and farmers markets. Experience a community where every day feels like a new adventure!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodcallout.title": {
    "overrideType": "VALUE",
    "customValue": "<p>See What's Right Outside Your Doorstep</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodmap.category_order": {
    "overrideType": "VALUE",
    "customValue": "Shopping & Retail, Education, Entertainment, Health and Wellness, Nature & Outdoor Attractions, Transportation & Transit, Major Employers & Offices, Restaurants",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.scheduler.header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertycontactinfo.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Search Ends Here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Skyline Farmers Market</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "residentaccesshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Ready to Make Skyline Farmers Market Your New Home?</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.scheduler_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Virtual Tours</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=48/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartment-sync-loader.inject_dni_classes": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "cort-lead-form.form_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_cort_lead_form_id"
  },
  "deals-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>CORT Furniture Rental</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "engrain-sitemap.sitemap_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_engrain_sightmap_url"
  },
  "facebook-pixel.pixel_ids": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_pixel_id"
  },
  "floor-plans-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span>Skyline Farmers Market offers gorgeous studio, one, and two-bedroom floor plans to meet your needs and lifestyle. Each home is thoughtfully designed and features elevated touches, including custom designer cabinetry and private patios and balconies.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.text_us_label": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_text_us_link"
  },
  "pageblurb.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Contact Us",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccess.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "schedule-tour-blurb.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatour.form.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Skyline Farmers Market offers a wide range of community and apartment amenities for our residents. Enjoy living in one of our beautiful homes featuring tall ceilings, gourmet kitchens with granite countertops, and private patios and balconies. You’ll love additional touches in select homes, such as custom solar shades and beautiful dual vanities. At our community amenities, you can swim in our resort-style pool, relax at the Zen Courtyard, and workout at our state-of-the-art fitness center. Learn more below about why Skyline Farmers Market Apartment Homes is the right place for your new home!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Exceptional Amenities at Our Apartments in Dallas, Texas</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At Skyline Farmers Market in Dallas, we offer a variety of thoughtfully designed floor plans to suit your lifestyle, including cozy studios, spacious one-bedroom, and inviting two-bedroom apartments. Have questions about your future home? Reach out to our leasing team today – we’re here to help you find the perfect fit!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card2.description": {
    "overrideType": "VALUE",
    "customValue": "<p>View Photo Gallery</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card3.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Browse Amenities</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Apartments in Dallas, TX</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Select a layout below to view current availability and pricing.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore our high-resolution photo gallery to get a sneak peek at Skyline Farmers Market Apartment Homes. Take a look at the various rooms in our actual apartments and notice the elegant touches, such as the modern, chef-inspired kitchen, perfect for preparing a beautiful meal while enjoying the Dallas skyline. We’re also nestled in the heart of Downtown, so you can check out the countless eateries, entertainment venues, and shops that are just steps from home.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "galleryhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore Photos of Our Dallas Apartments</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Schedule your tour of Skyline Farmers Market Apartment Homes in Dallas, TX, today! When you visit, you’ll be pleased to find studio, one, and two-bedroom apartments surrounded by premium amenities.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemaphero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore Your New Home Virtually</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Tucked away in the heart of Downtown, Skyline Farmers Market embodies the ideal “live-work-play” environment. Your prime location enables you to explore the city's unique offerings, including Klyde Warren Park, Deep Ellum, and the Dallas Arts District. Close to home, indulge in local eateries and bars like Revolver Taco, Saaya, Terry Black’s BBQ, or enjoy a performance at the One Eyed Penguin and Winspear Opera House, all within minutes of one another. For those seeking natural beauty, take advantage of the breathtaking Trinity Skyline Trail, and sports lovers can cheer on the Dallas Mavericks NBA at the American Airlines Center. Enjoy convenient access to US-75, I-30, and the light rail, ensuring a quick and efficient commute to major employers such as AT&T, Tenet Health, and McAfee. Families will also value living within the highly rated Dallas Independent School District.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Everything You Need, Right Outside Your Doorstep in Dallas, TX</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span>At Skyline Farmers Market, we’re not just pet-friendly, we LOVE pets and show it by providing a treats in the office and hosting frequent Yappy Hours, an event for dogs and their owners to socialize, take pics in a photo booth, eat snacks and get beautified by the visiting dog groomer.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.description": {
    "overrideType": "VALUE",
    "customValue": "<p><span>At Skyline Farmers Market, we’re not just pet-friendly, we LOVE pets and show it by providing a treats in the office and hosting frequent Yappy Hours, an event for dogs and their owners to socialize, take pics in a photo booth, eat snacks and get beautified by the visiting dog groomer.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions": {
    "overrideType": "VALUE",
    "customValue": "<ul><li><p><span style=\"font-size: 11pt;\">Pit Bull &amp; Pit Bull Mixes&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">American Pit Bull Terrier&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">American Staffordshire Terrier&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Wolf Hybrids&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Doberman Pinscher&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Saint Bernard&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">American Bulldog&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Staffordshire Bull Terrier&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Rottweiler&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">German Shepherd&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Chow Chow&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Great Dane&nbsp;</span></p></li><li><p><span style=\"font-size: 11pt;\">Akita&nbsp;</span></p></li></ul>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.welcome_text": {
    "overrideType": "VALUE",
    "customValue": "<p>PETS</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicycontent.body": {
    "overrideType": "VALUE",
    "customValue": "<div> <div> <div> <h2> <span>Privacy Policy</span> </h2> <p> <span> <span>We value your trust. The following online privacy policy is intended to protect and secure the personally identifiable information (any information by which you can be identified) you provide to our organization online.&nbsp;</span> </span> </p> <p><br></p> <h2> <span>Information We Collect</span> </h2> <p> <span>We collect information from visitors on our Web site through online requests including:</span> </p> <ul> <li> <span>Contact Requests</span> </li><li> <span>Schedule a Tour Requests</span> </li> </ul> <p><br></p> <p> <span> <span>The information we collect online includes name, address, city, state, ZIP/postal code, telephone number, e-mail address. In order to continuously improve our service and meet your needs we may also ask you to provide information specific to your organization.&nbsp;</span> </span> </p> <p><br></p> <h2> <span>How the Information is Used</span> </h2> <p> <span> <span>We use your information to communicate with you, and understand your needs to provide you with better service. We may use your information to complete a transaction, to update you on projects or to personalize our Web site for you. We also provide you the opportunity to remove your name from our mailing lists, if you desire to do so. Please review the corresponding section of this privacy policy below. n addition, we will not send you e-mail that you have not agreed to receive. We may periodically send you e-mail announcing news and event information.&nbsp;</span> </span> </p> <p><br></p> <h2> <span>Sharing of Personal Information</span> </h2> <p> <span> <span>We never sell, rent, lease or exchange your personal information with other organizations. We assure you that the identity of all who contact us through this Web site will be kept confidential.&nbsp;</span> </span> </p> <p><br></p> <h2> <span>Security</span> </h2> <p> <span> <span>We are committed to ensuring the security of your personal information. To prevent unauthorized access, maintain data accuracy, and ensure the proper use of information, we have established and implemented appropriate physical, electronic and managerial procedures to safeguard and secure the information we collect online.&nbsp;</span> </span> </p> <p><br></p> <h2> <span>Cookies</span> </h2> <p> <span> <span>From time to time, we may send a “cookie” to your computer. A cookie is a small piece of data that is sent to your browser from a Web server and stored on your computer’s hard drive. A cookie can’t read data off your hard drive or read cookie files created by other sites. Cookies do not damage your system. We use cookies to recognize you when you return to our sites, or to identify which areas of our network of Web sites you have visited. We may use this information to better personalize the content you see on our sites. Many Web sites place cookies on your hard drive. You can choose whether to accept cookies by changing the settings of your browser. Your browser can refuse all cookies, or show you when a cookie is being sent. If you choose not to accept these cookies, your experience at our site and other Web sites may be diminished and some features may not work as intended.&nbsp;</span> </span> </p> <p><br></p> <h2> <span>Links to Outside Sites</span> </h2> <p> <span> <span>This Web site links to documents located on Web sites maintained by other organizations or individuals. Once you access a link to another Web site, please be aware that we are not responsible for the privacy practices or the content of such Web sites.&nbsp;</span> </span> </p> <p><br></p> <h2> <span>Removal from Our Mailing List</span> </h2> <p> <span> <span>We give you the opportunity to remove your name from our postal mailing list so that you do not receive any future communications. If you desire to permanently remove your name, you can contact us. If you determine that our information about you is inaccurate or it has changed, you may also modify information by contacting customer service.&nbsp;</span> </span> </p> <p><br></p> <h2> <span>Contacting Us</span> </h2> <p> <span>If you have comments or questions about our online privacy policy, or would like more information about us, or are experiencing technical trouble, please contact us.</span> </p> <p><br></p> </div> </div> </div>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Searching for apartments for rent in Dallas Texas in the Farmers Market District? Experience the charm of vibrant Texas life at Skyline Farmers Market Apartments. Our pet-friendly community boasts luxurious apartment amenities, captivating city views, and a convenient location close to local shopping, dining, and the bustling Dallas Farmers Market District.</p><p><br></p><p>At Skyline Farmers Market, you’ll find modern community features designed to enhance your life. Upscale finishes like granite countertops, kitchen islands, and stainless steel appliances add an extra element of appeal to our well-designed community. Whether you’re looking for a studio, one-bedroom, or two-bedroom floor plans near the Dallas Farmers Market District, you’ll feel right at home in a space that fits your needs. Relax by our resort-inspired pool, or work out in the high-end fitness center. With a secure parking garage, electric vehicle charging stations, and easy access to explore the Dallas Farmers Market District, we make your day-to-day downtown living effortless.</p><p><br></p><p>Our Dallas Farmers Market District apartments include a blend of comfort and connection. Walk to pick up fresh produce or explore nearby restaurants. Whether you’re planning to work from home or take time to unwind, our spaces provide everything you need for balance. Schedule a tour today to find your next chapter and discover the focal point of life in Dallas, Texas. From the pet-friendly amenities to the community’s thoughtful touches, you’ll see why Skyline Farmers Market Apartments are more than just a home—they bring you closer to the heart of Dallas Texas.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p><span>Take a virtual stroll through&nbsp; <span>Skyline Farmers Market</span> - view our collection of photography that highlights our convenient amenities, bright &amp; homey apartment interiors, and the overall feel of our community.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Schedule your tour of Skyline Farmers Market Apartment Homes in Dallas, TX, today! When you visit, you’ll be pleased to find studio, one, and two-bedroom apartments surrounded by premium amenities.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore Your New Home</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyoucontent.body": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank you for your interest in Skyline Farmers Market in vibrant Dallas! Our diverse floor plans, featuring cozy studios to spacious two-bedroom apartments, offer the perfect blend of style and comfort. Expect a prompt response from our team to help guide you to your ideal living space.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Schedule your tour of Skyline Farmers Market Apartment Homes in Dallas, TX, today! When you visit, you’ll be pleased to find studio, one, and two-bedroom apartments surrounded by premium amenities.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore Your New Home Virtually</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitieslist.community_photo_5": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d4512-1d09-77be-a529-5b7b0fee85cc.webp"
      },
      "url": {
        "type": "VALUE",
        "customValue": "https://www.repli360.com"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "deals.image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5122712762580992/019fae70-64a9-737c-bd22-a02e41f70377.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Interior view of a staged apartment living room with furniture and decor."
      }
    }
  },
  "footer.love_notes_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d44f3-3412-75a9-9aac-8f5678cb59df.webp"
      }
    }
  },
  "footer.managed_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0216-ecfb-7511-93a8-11521f53aa62.webp"
      }
    }
  },
  "footer.powered_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d4512-9e41-741d-9389-24d537b59073.webp"
      },
      "url": {
        "type": "VALUE",
        "customValue": "https://www.multihub.io/"
      }
    }
  },
  "footer.text_us_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": ""
      },
      "phone": {
        "type": "FIELD_MAPPING",
        "mappedField": "custom_text_us_link"
      }
    }
  },
  "footer.weidner_cares_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d44f3-3452-767e-8966-83b6939f057f.webp"
      }
    }
  },
  "header.qualifying_criteria_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/qualifying-criteria"
      }
    }
  },
  "header.resident_access_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_resident_portal_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "header.schedule_tour_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/schedule-a-tour"
      }
    }
  },
  "neighborhoodcallout.image_1": {
    "sourceIndex": 16,
    "fieldOverrides": null
  },
  "pageblurb.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Schedule Tour"
      },
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "amenitieshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[18].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[18].image_media.alt_text"
      }
    }
  },
  "contacthero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[16].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[16].image_media.alt_text"
      }
    }
  },
  "dallasmavericksgames.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://mavs.spinzo.com/?group=corporate-group-offers-f6xp&affiliate=skyline-farmers-market-udc7"
      }
    }
  },
  "floorplanshero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[3].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[3].image_media.alt_text"
      }
    }
  },
  "footer.logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019f81ab-9653-737f-93c2-4f5385f15026.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Skyline Farmers Market logo with a city skyline silhouette."
      }
    }
  },
  "galleryhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[23].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[23].image_media.alt_text"
      }
    }
  },
  "header.logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166060/019f81ab-9653-737f-93c2-4f5385f15026.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Skyline Farmers Market logo with a city skyline silhouette."
      }
    }
  },
  "hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[23].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[23].image_media.alt_text"
      }
    }
  },
  "neighborhoodhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[26].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[26].image_media.alt_text"
      }
    }
  },
  "petpolicyhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[22].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[22].image_media.alt_text"
      }
    }
  },
  "scheduleatourhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[14].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[14].image_media.alt_text"
      }
    }
  },
  "virtualtourhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[4].image"
      },
      "alt": {
        "type": "FIELD_MAPPING",
        "mappedField": "photo_gallery[4].image_media.alt_text"
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.carousel_images": {
    "limit": 1,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.gallery_images": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": [
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31,
      32,
      33,
      34,
      35,
      36,
      37,
      38,
      39,
      40,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      48,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      58,
      59,
      60,
      61
    ],
    "customItems": null
  },
  "overview.images": {
    "limit": null,
    "hiddenIds": [
      "ec_04b625014fdd6f867ad4e05d"
    ],
    "orderedIds": null,
    "hiddenIndices": [
      5
    ],
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "cort-lead-form",
      "blockId": "cort-lead-form",
      "position": 0
    },
    {
      "sectionId": "facebook-pixel",
      "blockId": "facebook-pixel",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 11
    }
  ],
  "interactive-map": [
    {
      "sectionId": "apartment-sync-map",
      "blockId": "apartment-sync-map",
      "position": 11
    }
  ]
};

export const styleOverrides = {
  "hero.subtitle": {
    "properties": {
      "textAlign": "center"
    }
  },
  "_section.CortLeadFormCta": {
    "properties": {
      "paddingBottom": "50px",
      "backgroundColor": "#ffffff"
    }
  },
  "footer.love_notes_logo": {
    "properties": {
      "paddingLeft": "10px"
    }
  },
  "hero.title": {
    "properties": {
      "paddingTop": "120px"
    }
  }
};
